import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import Region from 'components/regionalization/Region';
import Cookies from "cookies-js";
import Arrow from "components/regionalization/Arrow";


class RegionSwitcher extends Component {

  /**
   * these need to be the same number
   * @type {{regions: *, links: *}}
   */
  static propTypes = {
    abstractTitle: PropTypes.string,
    abstractIntro: PropTypes.string,
    regions: PropTypes.string,  //region name
    links: PropTypes.string,    //link to a region page
    images: PropTypes.string,
    horizontal: PropTypes.bool,
    itemContentHorizontal: PropTypes.bool,
    forceRedirect: PropTypes.bool,
    fullView: PropTypes.bool,
    setRegion: PropTypes.func,
    bgColor: PropTypes.string,
    itemBgColor: PropTypes.string,
    headerTextColor: PropTypes.string,
    textColor: PropTypes.string,
    collapsed: PropTypes.bool,
    mainImage: PropTypes.string
  };

  static defaultProps = {
    abstractTitle: '',
    abstractIntro: '',
    regions: '',
    links: '',
    images: '',
    horizontal: true,
    itemContentHorizontal: true,
    forceRedirect: true,
    fullView: false,
    setRegion: null,
    bgColor: '',
    itemBgColor: '',
    headerTextColor: '',
    textColor: '',
    collapsed: false,
    mainImage: null
  };

  state = {
    region: '',
    isOpen: false
  };

  componentWillMount() {
    this.cookieDomain = '';
    if (process.env.BROWSER) {
      let regionLink;
      let loc = window.location.href.split('.');
      let domain0, domain1;

      if (loc && loc.length >= 3) {
        domain0 = loc.length - 2;
        domain1 = loc.length - 1;

        loc[domain1] = loc[domain1].replace(/:[0-9]+/gi, '').replace(/\/.+/gi, '').replace(/\//gi, '');

        this.cookieDomain = `${loc[domain0]}.${loc[domain1]}`;

        if (this.props.forceRedirect && this.props.fullView) {
          regionLink = Cookies.get('regionLink');
          if (regionLink) {
            if (window.location.href !== regionLink) {
              window.location.href = regionLink;
            }
          }
        }
      }
    }
  }

  componentDidMount() {
    const MOBILE_SCREENSIZE = 768;
    if (this.props.fullView) {
      if (window.innerWidth >= MOBILE_SCREENSIZE) {
        let parent = ReactDOM.findDOMNode(this).parentNode.parentNode;
        parent.setAttribute("style", "position:inherit; padding-left:0px; padding-right:0px");
      }

      let page = document.getElementById("page");
      page.setAttribute("style", `background-color: ${this.props.bgColor};`);
    }
  }

  render() {
    let {
      abstractTitle = '',
      abstractIntro = '',
      regions = '',
      links = '',
      images = '',
      horizontal,
      itemContentHorizontal,
      fullView,
      forceRedirect,
      bgColor,
      itemBgColor,
      headerTextColor,
      textColor,
      collapsed,
      mainImage
    } = this.props;
    regions = regions.trim().split(',');
    links = links.trim().split(',');
    images = images.trim().split(',');

    regions = regions.map(region => {
      return region.trim();
    });

    images = images.map(image => {
      return image.trim();
    });

    links = links.map(link => {
      return link.trim();
    });

    let storedRegion;
    if (process.env.BROWSER) {
      let subdomain = location.hostname.split('.');
      if (subdomain.length) {
        subdomain = subdomain[0].toLowerCase();

        let link, linkSubDomain;
        for (let i = 0; i < links.length; i++) {
          link = links[i];
          linkSubDomain = link.split('.')[0];
          linkSubDomain = linkSubDomain.split('//')[1];

          if (linkSubDomain.length > subdomain.length) {
            if (linkSubDomain.includes(subdomain)) {
              storedRegion = regions[i];
              break;
            }
          } else {
            if (subdomain.includes(linkSubDomain)) {
              storedRegion = regions[i];
              break;
            }
          }
        }

        if (storedRegion === 'www' || storedRegion === 'localhost') {
          storedRegion = null;
        }
      }
    }

    let title, intro, regionContainer, direction, region, image, rxp, mainImg;
    let parentStyling = {}, localStyling = {}, headerItem, headerItemContent, menuItems, arrow, dropDownCSS, localMenuItemsHolderCSS;
    let regionItems = links.map((link, index) => {
      if (regions[index]) {
        region = regions[index].trim();
      } else {
        region = null;
      }

      link = `${link.trim()}/`;
      rxp = /[a-z]/gi;

      if (images[index] && rxp.test(images[index])) {
        image = images[index].trim();
      } else {
        image = null;
      }

      return (
        <Region key={`region_${index}`}
                fullView={fullView}
                bgColor={itemBgColor}
                textColor={textColor}
                collapsed={collapsed}
                cookieDomain={this.cookieDomain}
                region={{
          text: (region || '').trim(),
          link,
          image,
          forceRedirect,
          itemContentHorizontal,
          fullView
        }}/>);
    });

    //default - will take up whatever parent space there is
    if (fullView) {
      title = (<div className={"title"}>{abstractTitle}</div>);
      intro = (<div className={"intro-blurb"}>{abstractIntro}</div>);

      if (mainImage) {
        mainImg = (<div className={"mainImage"}><img src={mainImage} /></div>);
      }

      parentStyling = {
        'background-color': `${bgColor}`,
        'align-items': 'center',
        "justify-content": "center",
        "padding": "10px",
        "overflow-y": "scroll",
        "color": `${textColor}`,
        'left': `0`,
        'top': `0`,
        'right': `0`,
        'bottom': `0`
      };

      if (horizontal) {
        direction = 'row';
      } else {
        direction = 'column';
      }

      localStyling = {
        "display": "flex",
        "flex-direction": direction,
        'align-items': 'center',
        "justify-content": "space-around",
        "flex-wrap": "wrap",
        "width": '100%'
      };

      regionContainer = (
        <div className={"menuItems"} style={localStyling}>
          { regionItems }
        </div>
      );

    //will appear as a menu in a parent such as collapsibleHeader
    } else {
      let left, top, bottom, marginTop, position;
      if (collapsed) {
        left = "-100px";
        top = '15px';
        position = "absolute";
        localMenuItemsHolderCSS = {
          marginTop: "0px"
        };
      } else {
        left = "0px";
        bottom = '0px';
        marginTop = "5px";
        position = "";
        localMenuItemsHolderCSS = {
          minWidth: "300px",
          marginTop: "-5px"
        };
      }

      parentStyling = {
        "position": `${position}`,
        "margin-top": `${marginTop}`,
        "left": `${left}`,
        "top": `${top}`,
        "bottom": `${bottom}`,
        "min-width": "200px",
        "padding": "0",
        "cursor": "pointer"
      };

      if (!collapsed) {
        if (this.state.isOpen) {
          arrow = <Arrow rotate color={headerTextColor} />;
        } else {
          arrow = <Arrow color={headerTextColor}/>;
        }
      }

      if (storedRegion) {
        headerItemContent = <div className={'headerItemContent'}>Region: {storedRegion} <div className={'arrow'}>{arrow}</div></div>;
      } else {
        headerItemContent = <div className={'headerItemContent'}>{'REGION SELECT' }  <div className={'arrow'}>{arrow}</div></div>;
      }

      let fontSize = 'medium';
      if (collapsed) {
        fontSize = 'small';
      }
      let headerItemStyle = {
        "font-size": fontSize,
        "color": headerTextColor
      };

      headerItem = (<div className={'headerItem'} style={headerItemStyle} onMouseEnter={() => {
        this.setState({
          isOpen: true
        });
      }} onClick={() => {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }}>{headerItemContent}</div>);

      dropDownCSS = {
        "flex-direction": "column",
          "justify-content": "flex-start",
          "align-items": "flex-start",
          'position': 'absolute',
          'top': 0
      };

      if (this.state.isOpen) {
        menuItems = regionItems;
        localMenuItemsHolderCSS.minWidth = "300px";
      }

      //item parents
      regionContainer = (
        <div className={"menuItems"} style={dropDownCSS} onMouseLeave={() => {
          this.setState({
            isOpen: false
          });
        }}>
          { headerItem }
          <div className={"menu-items-holder"} style={localMenuItemsHolderCSS}>
          { menuItems }
          </div>
        </div>
      );
    }

    let classType;
    if (fullView) {
      classType = "full-view";
    } else {
      classType = "drop-down";
    }

    return (
      <div className={`Regionalization ${classType}`}
           style={ parentStyling }>
        <div className={"intro"}>
          {mainImg}
          {title}
          {intro}
        </div>
        {regionContainer}
      </div>
    );
  }
}

export default RegionSwitcher;



// WEBPACK FOOTER //
// ./app/components/regionalization/RegionSwitcher.js